import { css } from 'glamor'

export default {
  header: css({
    borderBottom: '2px solid #ccc',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '10px',

    '.result &': {
      borderBottom: 'none',
      paddingBottom: '0px',
    }
  }),
  parameter: css({
    textAlign: 'center',
    margin: '10px 0',

    '@media(max-width: 700px)': {
      margin: '10px 0',
    }
  }),
  scoreBlock: css({
    position: 'relative',
    // width: '19px',
    height: '40px',
    margin: '0 auto',
  }),
  scoreWrapper: css({
    display: 'flex',
    position: 'absolute',
  }),
  text: css({
    marginRight: '5px',
  }),
  score: css({
    transition: 'transform .1s, font-weight .1s, color .2s'
  }),
  // scorePlus: css({
  //   color: '#00c100',
  // }),
  // scoreMinus: css({
  //   color: 'red',
  // }),
  animation: css({
    color: '#00c100',
    fontWeight: '900',
    transform: 'scale(2)',
  }),
  parameterBox: css({
    margin: '0 20px',
  }),
  parameterTitle: css({
    textTransform: 'uppercase',
    color: '#aaaaaa',
  }),
}



// WEBPACK FOOTER //
// ./src/components/Score/styles.js